import { Button } from '@cloudflare/kumo';
import { useQuery } from '@tanstack/react-query';
import { Outlet, useParams, useSearch } from '@tanstack/react-router';
import { chatQuery, sitesQuery } from '../api.ts';
import { ErrorNotice } from '../common.tsx';
import { ChatThread } from './chat.tsx';
import { SitePanel } from './site-panel.tsx';

export function Workbench({
  draft,
  view,
  onViewChange,
}: {
  draft: number;
  view: 'chat' | 'site';
  onViewChange: (view: 'chat' | 'site') => void;
}) {
  const params = useParams({ strict: false });
  const search = useSearch({ strict: false });
  const chatId = search.chatId;
  const chat = useQuery(chatQuery(chatId));
  const sites = useQuery(sitesQuery);
  const siteId = params.siteId ?? search.siteId ?? chat.data?.chat.contextSiteId ?? sites.data?.[0]?.id;
  const showSitePanel = Boolean(siteId);
  return (
    <main className="workbench" data-view={showSitePanel ? view : 'chat'} data-site-panel={showSitePanel}>
      {showSitePanel && (
        <div className="workbench-view-switch" aria-label="View">
          <Button
            variant={view === 'chat' ? 'secondary' : 'ghost'}
            onClick={() => onViewChange('chat')}
            aria-pressed={view === 'chat'}
          >
            Chat
          </Button>
          <Button
            variant={view === 'site' ? 'secondary' : 'ghost'}
            onClick={() => onViewChange('site')}
            aria-pressed={view === 'site'}
          >
            Site panel
          </Button>
        </div>
      )}
      <div className="workbench-chat">
        {!showSitePanel && <ErrorNotice error={sites.error} className="m-4" />}
        <ChatThread key={chatId ?? draft} chatId={chatId} selectedSiteId={siteId} />
      </div>
      {showSitePanel && (
        <SitePanel siteId={siteId} chatId={chatId}>
          <Outlet />
        </SitePanel>
      )}
    </main>
  );
}
